module.exports = __webpack_public_path__ + "media/images/review-ad76d769a51526311ae314fd10f47821.svg";